import { render, staticRenderFns } from "./float_ad.vue?vue&type=template&id=fa9b1b1a&scoped=true&"
import script from "./float_ad.vue?vue&type=script&lang=js&"
export * from "./float_ad.vue?vue&type=script&lang=js&"
import style0 from "./float_ad.vue?vue&type=style&index=0&id=fa9b1b1a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa9b1b1a",
  null
  
)

export default component.exports